import * as yup from "yup";

export const ResourceSchema = yup.object().shape({
  name: yup.string().required(),
  price: yup.number().min(0).required(),
  categoryId: yup.number().required(),
});
